import { Injector, Input, Directive } from '@angular/core';
import { KalgudiDialogsService } from '@kalgudi/common';
import { KalgudiDestroyable } from '@kalgudi/core';
import { KalgudiNotification, KL_NOTIFICATION } from '@kalgudi/core/config';
import { KalgudiDialogResult, KalgudiUserCertificateDetails } from '@kalgudi/types';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  KalgudiProfileCertificatesService,
} from '../../../components/sections/certifications/kalgudi-profile-certificates.service';
import { KalgudiProfileActionService } from '../../../services/kalgudi-profile-action.service';
import { KalgudiProfileService } from '../../../services/kalgudi-profile.service';

@Directive()
export abstract class KalgudiEmployeeCertificates  extends KalgudiDestroyable {

  @Input()
  certificates: KalgudiUserCertificateDetails[];

  editable: boolean;

  private dialogsService: KalgudiDialogsService;
  private certificateService: KalgudiProfileCertificatesService;
  private notification: KalgudiNotification;
  private profileActionService: KalgudiProfileActionService;
  private profileService: KalgudiProfileService;

  constructor(protected injector: Injector) {

    super();

    this.dialogsService       = this.injector.get(KalgudiDialogsService);
    this.certificateService   = this.injector.get(KalgudiProfileCertificatesService);
    this.notification         = this.injector.get<KalgudiNotification>(KL_NOTIFICATION);
    this.profileActionService = this.injector.get(KalgudiProfileActionService);
    this.profileService       = this.injector.get(KalgudiProfileService);

    this.profileService.editable$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe(
        res => this.editable = res
      );

  }

  // --------------------------------------------------------
  // #region Public methods
  // --------------------------------------------------------

  /**
   * Deletes certificate
   */
  deleteCertificate(certificateId: string) {

    this.certificateService.deleteCertificate(certificateId)
      .pipe(
        // Subscribe to the stream only till the component is alive
        takeUntil(this.destroyed$),
      )
      .subscribe(
        res => this.onCertificateDeleted(res),
        err => this.onCertificateFailed(err)
      );
  }

  /**
   * Updates certificate
   */
  updateCertificate(certificateId: string, certificateDetails: KalgudiUserCertificateDetails): Observable<KalgudiDialogResult> {
    return this.profileActionService.updateCertificate(certificateId, certificateDetails)
      .pipe(
        takeUntil(this.destroyed$)
      );
  }

  /**
   * Shows add certificate dialog
   */
  showAddCertificateDialog(): Observable<KalgudiDialogResult> {

    return this.profileActionService.showAddCertificateDialog()
      .pipe(
        takeUntil(this.destroyed$),
      );
  }

  // --------------------------------------------------------
  // #endregion
  // --------------------------------------------------------


  // --------------------------------------------------------
  // #region Private and protected methods
  // --------------------------------------------------------


  /**
   * Certificate deleted successfully
   */
  protected onCertificateDeleted(res) {
    this.notification.showMessage('Certificate deleted');
  }

  /**
   * Failed to deleted certificate
   */
  protected onCertificateFailed(err) {
    this.notification.showMessage('Failed to delete certificate, please try again later!');
  }


  // --------------------------------------------------------
  // #endregion
  // --------------------------------------------------------

}
